import { KeycloakTokenParsed } from 'keycloak-js';

export enum UserRole {
  Manager = 'manager',
  Viewer = 'viewer',
}

export interface ITokens {
  token: string;
  refreshToken: string;
}

/**
 * Extra, non-OIDC fields returned at the top level of the /api/v1/auth/token response
 * (siblings of access_token). keycloak-js does not expose these, so they are captured
 * separately — see tokenResponseInterceptor.
 */
export interface ITokenExtras {
  excludedScope: string[];
}

export interface IAuthStore {
  isAuthenticated: boolean;
  isLoggingOut?: boolean;
  authError?: string;
  idTokenParsed?: KeycloakTokenParsed;
  apiToken?: string;
  apiTokenParsed?: KeycloakTokenParsed;
  excludedScope?: string[];
}

export interface IAuthStoreSegment {
  auth: IAuthStore;
}
